<template>
  <transition name="fade" mode="out-in">
    <router-view/>
  </transition>
</template>

<script>
export default {
  middleware: ['auth','admin']
}
</script>

<style>
.settings-card .card-body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/index.vue